import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P58-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page58/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page58/E1/2.jpg' },
      ]
    ]
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P58-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 2,
    exerciseKey: 'img/FriendsPlus/Page58/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page58/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page58/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/5.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page58/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/7.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page58/E2/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page58/E2/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page58/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/11.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page58/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/13.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page58/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/15.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E2/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page58/E2/17.jpg' },
      ],

    ]
  },
  3: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P58-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 5,
    exerciseKey: 'img/FriendsPlus/Page58/E3/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page58/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page58/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page58/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/5.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page58/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/7.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E3/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page58/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/10.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page58/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/12.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page58/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/14.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E3/15.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page58/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/17.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/19.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page58/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/21.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page58/E3/22.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page58/E3/23.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/24.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page58/E3/25.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/26.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E3/27.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/28.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page58/E3/29.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page58/E3/30.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/31.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page58/E3/32.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/33.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page58/E3/34.jpg' },
        { url: 'img/FriendsPlus/Page58/E3/35.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page58/E3/36.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page58/E3/37.jpg' },
      ],



    ]
  },



}
export default json;